/* Fit Finder test: follow shoppers from a test page to a product page (added 15 Oct 2026).

   Loaded site-wide (layout/theme.liquid). Does nothing visible. Four jobs:

   1. On a test page (v2_challenger / v3_cta / c_assistant), a click on a link to a product page logs
      step_view 'product_page_click' and leaves a marker in localStorage: which arm, which product page,
      when. The marker lasts 2 hours.
   2. On that same product page, within the 2 hours:
      - "Buy on Amazon" (US links only) is sent with the arm's Amazon Attribution tag instead of
        website_product, swapped at click time. Any other link is left exactly as it is.
      - the Amazon click logs step_view 'product_page_amazon_click' (once per marker);
      - an add to cart logs step_view 'product_page_add_to_cart' (once per marker).
   3. On any page, an add to cart by a visitor the round 2 split assigned to an arm stamps the cart with
      hidden attributes (_ff_arm, plus _ff_handoff when it follows a product-page click), so Shopify
      orders show which arm the buyer saw.
   4. Test membership goes in bundle_tier ('in_test' / 'outside'), like the connector events.

   Nothing here may break the page: every step is wrapped, clicks are never blocked or delayed. */
(function () {
  'use strict';
  if (window.__dgrArmHandoff) return;
  window.__dgrArmHandoff = true;

  var MARK_KEY = 'dongar_ff_handoff';
  var SPLIT_KEY = 'dongar_ff_variant_r2';
  var TTL_MS = 2 * 60 * 60 * 1000;
  var ARMS = ['v2_challenger', 'v3_cta', 'c_assistant'];

  /* US website_product ad group (the tag every amazon_listings US link carries) → each arm's ad group.
     Keep in sync with BUCKET_TAG in finder-attribution.js and the assistant's finder_assistant tag. */
  var WEBSITE_PRODUCT_TAG = 'F6A08B15BF236D52F66AE98D60A53ABB';
  var ARM_TAG = {
    v2_challenger: 'E2E5B32B6E54CB5894BC0F102DED0DC9', // finder_challenger
    v3_cta:        'F41134E009FFFB5AE562FD29DA1A6FAB', // finder_v3
    c_assistant:   'D072ACA7B363A0A352FC700F6467D5DB'  // finder_assistant
  };

  var SB = 'https://vdfgvxqwcjdupvtjhnmy.supabase.co/functions/v1/';
  var ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZkZmd2eHF3Y2pkdXB2dGpobm15Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzNjEwNzUsImV4cCI6MjA4ODkzNzA3NX0.EKFuutkb7vGysPMA3XsVuyuMbHCTalCVNETQqSZQEkE';

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }

  /* "/products/<handle>" part of a URL or path (also matches /collections/x/products/<handle>). */
  function productPath(href) {
    try {
      var m = /\/products\/([^\/?#]+)/.exec(new URL(href, location.href).pathname);
      return m ? '/products/' + m[1].toLowerCase() : null;
    } catch (e) { return null; }
  }

  function readMark() {
    var raw = lsGet(MARK_KEY);
    if (!raw) return null;
    try {
      var m = JSON.parse(raw);
      if (!m || ARMS.indexOf(m.arm) < 0 || !m.ts || Date.now() - m.ts > TTL_MS) { lsDel(MARK_KEY); return null; }
      return m;
    } catch (e) { lsDel(MARK_KEY); return null; }
  }
  function saveMark(m) { lsSet(MARK_KEY, JSON.stringify(m)); }

  /* Same endpoints and payload shape as the arm's own page: the finder pages log through the
     compatibility-api, the assistant through assistant-events (which stamps c_assistant itself). */
  function send(arm, payload) {
    try {
      var A = window.DongarAttribution;
      if (payload.bucket == null && A && typeof A.bucket === 'function') payload.bucket = A.bucket() || null;
      if (payload.source == null && A && typeof A.source === 'function') payload.source = A.source() || null;
      var url;
      if (arm === 'c_assistant') {
        url = SB + 'assistant-events';
      } else {
        url = SB + 'compatibility-api?action=log_event';
        payload.page_variant = arm;
      }
      fetch(url, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'apikey': ANON, 'Authorization': 'Bearer ' + ANON },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (e) {}
  }
  function logStep(mark, step, sku) {
    send(mark.arm, { event_type: 'step_view', step: step, sku: sku || mark.sku || null,
      bundle_tier: mark.member, session_id: mark.sid || null });
  }

  /* ── 1. Test pages: product-page clicks ── */
  var pageArm = window.DongarPageVariant;
  var onTestPage = ARMS.indexOf(pageArm) >= 0;
  if (onTestPage) {
    document.addEventListener('click', function (e) {
      try {
        var a = e.target && e.target.closest && e.target.closest('a[href]');
        if (!a) return;
        /* Only links inside the finder (dcf-*) or the assistant (dgr-ai*), not the header, menu or footer. */
        if (!a.closest('[class*="dcf-"], [class*="dgr-ai"]')) return;
        var path = productPath(a.href);
        if (!path) return;
        if (new URL(a.href, location.href).origin !== location.origin) return;
        var skuEl = a.closest('[data-product-sku]');
        var sid = typeof window.dongarGetVisitorId === 'function' ? window.dongarGetVisitorId() : null;
        var mark = {
          arm: pageArm,
          member: lsGet(SPLIT_KEY) === pageArm ? 'in_test' : 'outside',
          path: path,
          sku: skuEl ? skuEl.getAttribute('data-product-sku') : null,
          sid: sid || null,
          ts: Date.now()
        };
        saveMark(mark);
        logStep(mark, 'product_page_click');
      } catch (err) {}
    }, true);
  }

  /* ── 2. Product page reached from a test page ── */
  var mark = onTestPage ? null : readMark();
  var onMarkedPage = !!(mark && productPath(location.href) === mark.path);

  if (onMarkedPage) {
    var swap = function (e) {
      try {
        var a = e.target && e.target.closest && e.target.closest('a[href]');
        if (!a) return;
        var m = readMark();
        if (!m || productPath(location.href) !== m.path) return;
        var href = a.href;
        if (!/^https:\/\/(www\.)?amazon\.com\//i.test(href)) return; // US store only
        if (href.indexOf('maas_adg_' + WEBSITE_PRODUCT_TAG) < 0) return; // only the standard product-page link
        a.href = href.replace('maas_adg_' + WEBSITE_PRODUCT_TAG, 'maas_adg_' + ARM_TAG[m.arm]);
        if (!m.amz) { m.amz = true; saveMark(m); logStep(m, 'product_page_amazon_click', a.getAttribute('data-sku')); }
      } catch (err) {}
    };
    document.addEventListener('click', swap, true);
    document.addEventListener('auxclick', swap, true);
  }

  /* ── 3. Add to cart anywhere: credit the arm ── */
  var cartTagged = false;
  function onCartAdd() {
    try {
      var m = readMark();
      if (m && productPath(location.href) === m.path && !m.atc) {
        m.atc = true; saveMark(m);
        logStep(m, 'product_page_add_to_cart');
      }
      var arm = lsGet(SPLIT_KEY);
      if (cartTagged || ARMS.indexOf(arm) < 0) return;
      cartTagged = true;
      var attrs = { _ff_arm: arm };
      if (m && m.arm === arm && productPath(location.href) === m.path) attrs._ff_handoff = 'product_page';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () { cartTagged = false; });
    } catch (e) {}
  }
  /* Watches network requests without touching them: any request to /cart/add (theme forms, quick
     buys, the finder's own buttons) shows up here once it has been sent. */
  try {
    if ('PerformanceObserver' in window) {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          if (/\/cart\/add(\.js)?(\?|$)/.test(en.name)) onCartAdd();
        });
      }).observe({ type: 'resource', buffered: false });
    }
  } catch (e) {}
})();
